import styles from './InfoView.module.css';

const defaultViewTabs = [
  { id: 'channels', label: 'Channels' },
  { id: 'blocks', label: 'Blocks' },
  { id: 'table', label: 'Table' },
];

const orderOptions = [
  { id: 'newest', label: 'Newest first' },
  { id: 'oldest', label: 'Oldest first' },
  { id: 'alphabetical', label: 'Alphabetical by title' },
  { id: 'random', label: 'Random' },
];

export default function InfoView({ profile, activeView, onViewChange, activeOrder, onOrderChange, lastModified, hideInfo, viewTabs = defaultViewTabs }) {

  return (
    <section className={styles.container}>
      {!hideInfo && (
        <div className={styles.infoCol}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTitle}>Info</span>
          </div>
          <div className={styles.infoContent}>
            {profile?.bio && <p className={styles.bio}>{profile.bio}</p>}
            {profile?.website && (
              <a
                href={profile.websiteUrl || '#'}
                className={styles.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                {profile.website}
              </a>
            )}
            <dl className={styles.meta}>
              {profile?.handle && (
                <div className={styles.metaRow}>
                  <dt>Username</dt>
                  <dd>@{profile.handle}</dd>
                </div>
              )}
              <div className={styles.metaRow}>
                <dt>Created</dt>
                <dd>{profile?.joined || 'February 2026'}</dd>
              </div>
              {lastModified && (
                <div className={styles.metaRow}>
                  <dt>Modified</dt>
                  <dd>{lastModified}</dd>
                </div>
              )}
            </dl>
          </div>
        </div>
      )}
      <div className={styles.viewCol}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>View</span>
        </div>
        <ul className={styles.viewTabs}>
          {viewTabs.map(tab => (
            <li key={tab.id}>
              <button
                className={`${styles.viewTab} ${activeView === tab.id ? styles.viewTabSelected : ''}`}
                onClick={() => onViewChange(tab.id)}
              >
                {activeView === tab.id && <span className={styles.dot} />}
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {(activeView === 'channels' || activeView === 'blocks' || activeView === 'table' || activeView === 'users') && (
        <div className={styles.orderCol}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionTitle}>Order</span>
          </div>
          <ul className={styles.viewTabs}>
            {orderOptions.map(opt => (
              <li key={opt.id}>
                <button
                  className={`${styles.viewTab} ${activeOrder === opt.id ? styles.viewTabSelected : ''}`}
                  onClick={() => onOrderChange(opt.id)}
                >
                  {activeOrder === opt.id && <span className={styles.dot} />}
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
